import styled from 'styled-components';
import { MediaQuery } from '../constants/size';

export const CenteredContent = styled.div`
  max-width: ${({ maxWidth = 768 }) => `${maxWidth}px`}; 
  margin: 0 auto;
`;

export const EllipsisSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NoWrapLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.75em;
  padding: 2px 6px;
  border: 1px solid var(--br-border);
  border-radius: 999px;
  background: var(--br-raised-surface);
  color: var(--br-muted);
  font-size: 0.75em;
  font-weight: 700;
  white-space: nowrap;
  &[data-active='true'] {
    background: var(--br-success-surface);
    border-color: var(--br-success-border);
    color: var(--br-success-text);
  }
`;

export const PaddedWrapper = styled.div`
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`;

export const MinWidthSpan = styled.span`
  ${MediaQuery.phone} {
    display: none;
  }
`;
